import _ from 'lodash';
import {DES, enc, mode, pad, MD5} from 'crypto-js';

const ENCRYPTION_KEY = 'f15D@m9$',
  ENCRYPTION_IV = 'kFc#MptC';

export default class CryptService {
  constructor() {
    'ngInject';
    // parse keys as binary from utf8 source string
    this.encryption_key = enc.Utf8.parse(ENCRYPTION_KEY);
    this.encryption_iv = enc.Utf8.parse(ENCRYPTION_IV);
  }

  encrypt(message) {
    return DES.encrypt(message, this.encryption_key, {iv: this.encryption_iv, mode: mode.CBC, padding: pad.Pkcs7})
      .toString();
  }

  decrypt(cryptogram, encoding = enc.Utf8) {
    // cryptjs does not handles spaces in base64 encoding, remove all of them before decrypting
    return DES.decrypt(cryptogram.replace(/\s/g, ''), this.encryption_key, {iv: this.encryption_iv, mode: mode.CBC, padding: pad.Pkcs7})
      .toString(encoding);
  }

  sign(payload) {
    return MD5(payload).toString();
  }

  decryptAndVerify(response, field) {
    let signature = response.MD5, payload = response[field];
    let clearText = this.decrypt(payload);
    if (signature !== this.sign(clearText)) {
      throw new Error("Invalid signature detected, signature '" + signature + "' doesn't match clear text: " + clearText);
    }
    return JSON.parse(clearText);
  }

}


// WEBPACK FOOTER //
// ./client/app/services/crypt_service.js